import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { E_Wirecount_Key, WirecountTypes } from "src/app/models/wire-count-labels";

@Component({
    selector: "app-digital-wire-count-component",
    templateUrl: "./digital-wire-count.component.html",
    styleUrls: ["./digital-wire-count.component.scss"],
    standalone: false
})
export class DigitalWireCountComponent implements OnInit, OnDestroy {
  @Input() testData;
  @Input() wcCount;
  @Input() tSCount;
  @Input() wct = "1";
  @Input() title = '';
  @Input() formType: number;
  wireData;
  wireCountTypes = WirecountTypes;
  wireCountKeyText = E_Wirecount_Key;

  constructor() {}

  ngOnInit() {
    this.wireData = JSON.parse(this.testData);
    for (let i = 0; i < this.wireData.length; i++) {
      this.wireData[i] = this.wireData[i].filter((x) => x && x.Value !== null);
    }
  }

  ngOnDestroy() {}
}
